import { useState, useEffect, useCallback, useMemo } from 'react'
import { useParams } from 'react-router'
import { useDispatch } from 'react-redux'
import { criarAlerta } from 'actions'
import useRouter from 'utils/useRouter'
import { useAuth } from 'hooks/useAuth'
import { useDescricaoTecnicaVestigioService } from 'hooks/useDescricaoTecnicaVestigioService'
import { useExameEficienciaService } from 'hooks/useExameEficienciaService'
import { useVestigioService } from 'hooks/useVestigioService'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { useOptionService } from 'hooks/useOptionService'
import { useFetch } from 'hooks/useFetch'
import { cutMaxLength } from 'utils/helpers'

export const useExameEficienciaBalistica = (route) => {
  const { currentUser } = useAuth()
  const fetch = useFetch()
  const params = useParams()
  const dispatch = useDispatch()
  const router = useRouter()

  const exameRealizadoService = useExameRealizadoService()
  const exameEficienciaService = useExameEficienciaService()
  const optionService = useOptionService()
  const vestigioService = useVestigioService()
  const descricaoTecnicaService = useDescricaoTecnicaVestigioService()

  // Estados de listagens
  const [descricoesTecnicasDeExame, setDescricoesTecnicasDeExame] = useState([])
  const [processandoDescricoesTecnicas, setProcessandoDescricoesTecnicas] = useState(false)
  const [atualizado, setAtualizado] = useState(false)
  const [descricoesHabilitadasParaExameQuimico, setDescricoesHabilitadasParaExameQuimico] = useState([])
  const [descricoesHabilitadasParaExtracaoDePadrao, setDescricoesHabilitadasParaExtracaoDePadrao] = useState([])
  const [processandoDescricoesHabilitadasParaExtracaoDePadrao, setProcessandoDescricoesHabilitadasParaExtracaoDePadrao] = useState(false)
  const [processandoDescricoesHabilitadasParaExameQuimico, setProcessandoDescricoesHabilitadasParaExameQuimico] = useState(false)
  
  // Opções auxiliares
  const [locaisGravacoesNumeracaoDeSerie, setLocaisGravacoesNumeracaoDeSerie] = useState([])
  const [processandoLocaisGravacoesNumeracaoDeSerie, setProcessandoLocaisGravacoesNumeracaoDeSerie] = useState(false)
  const [tiposVestigios, setTiposVestigios] = useState([])
  const [tiposVestigiosEspecificos, setTiposVestigiosEspecificos] = useState([])
  const [casosDoObjetoOrigem, setCasosDoObjetoOrigem] = useState([])

  // Operações de loading e seleções
  const [descricaoTecnicaSelecionada, setDescricaoTecnicaSelecionada] = useState(null)
  const [idDescricaoVestigioBalisticoSelecionado, setIdDescricaoVestigioBalisticoSelecionado] = useState(null)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [processandoAlteracaoRespostas, setProcessandoAlteracaoRespostas] = useState(false)
  const [respostasQuesitos, setRespostasQuesitos] = useState(null)

  // Controles de abertura dos modais
  const [openAnaliseEficiencia, setOpenAnaliseEficiencia] = useState(false)
  const [openExtracaoPadrao, setOpenExtracaoPadrao] = useState(false)
  const [openAnaliseQuimicoMetalografico, setOpenAnaliseQuimicoMetalografico] = useState(false)
  const [openAnaliseFisicoQuimico, setOpenAnaliseFisicoQuimico] = useState(false)

  // --- FORMULÁRIOS ESTADO ---

  // 1. Extração de Padrão
  const [formExtracaoState, setFormExtracaoState] = useState({
    values: {
      lacre: null,
      tipoEmbalagem: null,
      outroTipoEmbalagem: null,
      tiposGens: null,
      tiposEsps: null,
      tamanhoObjeto: null,
      descricao: null,
      contraprova: null,
      setorAtual: null,
      caso: null,
    },
    touched: {},
    errors: {},
  })

  // 2. Análise de Eficiência
  const [formAnaliseEficienciaState, setFormAnaliseEficienciaState] = useState({
    values: { resultado: null },
    touched: {},
    errors: {},
  })

  // 3. Exame Químico-Metalográfico
  const [formAnaliseQuimicoMetalograficoState, setFormAnaliseQuimicoMetalograficoState] = useState({
    values: { resultado: null, numeroSerie: null, locGravs: [], localGravacaoNumeracaoSerieInput: null },
    touched: {},
    errors: {},
  })

  // 4. Exame Revelação Físico-Químico
  const [formAnaliseRevelacaoFisicoQuimicoState, setFormAnaliseRevelacaoFisicoQuimicoState] = useState({
    values: { resultado: null, numeroSerie: null, locGravs: [], localGravacaoNumeracaoSerieInput: null },
    touched: {},
    errors: {},
  })

  // Form Adapters utilitários para manter compatibilidade com componentes filhos
  const createFormAdapter = (state, setState) => ({
    formState: state,
    setFormState: setState,
    handleChange: (event) => {
      event.persist?.()
      const { name, value, type, checked } = event.target
      setState((prev) => ({
        ...prev,
        values: { ...prev.values, [name]: type === 'checkbox' ? checked : value },
        touched: { ...prev.touched, [name]: true },
      }))
    },
    handleChangeNewValueByNameProperty: (event, newValue, property) => {
      setState((prev) => ({
        ...prev,
        values: { ...prev.values, [property]: newValue },
        touched: { ...prev.touched, [property]: true },
      }))
    },
    handleChangeWithModification: (event, modifier) => {
      event.persist?.()
      const { name, value } = event.target
      const modifiedValue = modifier ? modifier(value) : value
      setState((prev) => ({
        ...prev,
        values: { ...prev.values, [name]: modifiedValue },
        touched: { ...prev.touched, [name]: true },
      }))
    },
    hasError: (field) => !!(state.touched[field] && state.errors[field]),
  })

  const formExtracao = createFormAdapter(formExtracaoState, setFormExtracaoState)
  const formAnaliseEficiencia = createFormAdapter(formAnaliseEficienciaState, setFormAnaliseEficienciaState)
  const formAnaliseQuimicoMetalografico = createFormAdapter(formAnaliseQuimicoMetalograficoState, setFormAnaliseQuimicoMetalograficoState)
  const formAnaliseRevelacaoFisicoQuimico = createFormAdapter(formAnaliseRevelacaoFisicoQuimicoState, setFormAnaliseRevelacaoFisicoQuimicoState)

  // --- CARGA DE DADOS (APIs) ---

  const fetchLocaisGravacaoNumeracaoDeSerie = useCallback(async () => {
    try {
      const response = await optionService.listarOpcoesDeModeloAsync(
        'LOCAL_GRAVACAO_NUMERACAO_DE_SERIE_ARMA_DE_FOGO',
        setProcessandoLocaisGravacoesNumeracaoDeSerie
      )
      setLocaisGravacoesNumeracaoDeSerie(response || [])
    } catch (error) {
      console.error('Falha ao carregar locais de gravação:', error)
    }
  }, [])

  const fetchTiposVestigios = useCallback(async () => {
    try {
      const response = await vestigioService.listarTiposVestigiosAsync(setProcessandoOperacao)
      setTiposVestigios(response || [])
    } catch (error) {
      console.error('Falha ao carregar tipos de vestígios:', error)
    }
  }, [])

  const fetchTiposVestigiosEspecificos = useCallback(async () => {
    try {
      const response = await vestigioService.listarTiposVestigiosEspecificosAsync(setProcessandoOperacao)
      setTiposVestigiosEspecificos(response || [])
    } catch (error) {
      console.error('Falha ao carregar tipos de vestígios específicos:', error)
    }
  }, [])

  const fetchDescricoesDeExame = useCallback(async () => {
    try {
      const response = await descricaoTecnicaService.listarDescricoesTecnicasAtivasDeExameSolicitadoComAnalisesEficienciaAsync(
        params.idExameSolicitado,
        setProcessandoDescricoesTecnicas
      )
      setDescricoesTecnicasDeExame(response || [])
    } catch (error) {
      console.error('Falha ao carregar descrições de exame:', error)
    }
  }, [params.idExameSolicitado])

  const fetchDescricoesHabilitadasParaExameQuimico = useCallback(async () => {
    try {
      const response = await descricaoTecnicaService.listarDescricoesVestigiosBalisticosNaoArtesanaisESemNumeracaoDeExameAsync(
        params.idExameRealizado,
        setProcessandoDescricoesHabilitadasParaExameQuimico
      )
      setDescricoesHabilitadasParaExameQuimico(response || [])
    } catch (error) {
      console.error('Falha ao carregar descrições para exame químico:', error)
    }
  }, [params.idExameRealizado])

  const fetchDescricoesHabilitadasParaExtracaoDePadrao = useCallback(async () => {
    try {
      const response = await descricaoTecnicaService.listarDescricoesTecnicasAtivasDeExameSolicitadoComColetaPadraoHabilitadaAsync(
        params.idExameSolicitado,
        setProcessandoDescricoesHabilitadasParaExtracaoDePadrao
      )
      setDescricoesHabilitadasParaExtracaoDePadrao(response || [])
    } catch (error) {
      console.error('Falha ao carregar descrições para extração de padrão:', error)
    }
  }, [params.idExameSolicitado])

  const fetchCasosDoObjetoOrigem = useCallback(async (idVestigio) => {
    try {
      const response = await vestigioService.listarCasosDeVestigio(idVestigio)
      setCasosDoObjetoOrigem(response || [])
    } catch (error) {
      console.error('Falha ao carregar casos do objeto origem:', error)
    }
  }, [])

  const fetchExameEficiencia = useCallback(async () => {
    // if (params.idExameRealizado) {
    //   try {
    //     const response = await exameEficienciaService.listarExameEficienciaAsync(params.idExameRealizado)
    //     if (!response) {
    //       // await fetch.postOpenWithoutFeedback(
    //       //   `/examesRealizados/adicionarExameEspecializadoInicial/${params.idExameRealizado}`,
    //       //   { tipoExame: route.tipoExame }
    //       // )
    //       // await exameEficienciaService.listarExameEficienciaAsync(params.idExameRealizado)
    //     }
    //   } catch (error) {
    //     console.error('Falha ao inicializar exame de eficiência:', error)
    //     dispatch(
    //       criarAlerta(
    //         { status: 501 },
    //         router,
    //         `/casos/caso/solicitacao/exameSolicitado/detalhar/${params.idExameSolicitado}`
    //       )
    //     )
    //   }
    // }
  }, [params.idExameRealizado, params.idExameSolicitado, route.tipoExame])

  // --- CARGA INICIAL POR EFFECTS ---
  useEffect(() => {
    fetchDescricoesDeExame()
    fetchDescricoesHabilitadasParaExameQuimico()
    fetchDescricoesHabilitadasParaExtracaoDePadrao()
    fetchTiposVestigios()
    fetchTiposVestigiosEspecificos()
    fetchLocaisGravacaoNumeracaoDeSerie()
    fetchExameEficiencia()
  }, [
    fetchDescricoesDeExame,
    fetchDescricoesHabilitadasParaExameQuimico,
    fetchDescricoesHabilitadasParaExtracaoDePadrao,
    fetchTiposVestigios,
    fetchTiposVestigiosEspecificos,
    fetchLocaisGravacaoNumeracaoDeSerie,
    fetchExameEficiencia,
    atualizado
  ])

  // --- VALIDATORS E SELETORES REATIVOS ---

  const isFormExtracaoInvalid = useMemo(() => {
    const vals = formExtracaoState.values
    return (
      !vals.lacre ||
      !vals.tipoEmbalagem ||
      !vals.tiposGens ||
      !vals.tiposEsps ||
      !vals.descricao ||
      !vals.setorAtual ||
      !vals.caso
    )
  }, [formExtracaoState.values])

  const isFormAnaliseEficienciaInvalid = useMemo(() => {
    return !formAnaliseEficienciaState.values.resultado
  }, [formAnaliseEficienciaState.values.resultado])

  const isFormQuimicoMetalograficoInvalid = useMemo(() => {
    return !formAnaliseQuimicoMetalograficoState.values.resultado
  }, [formAnaliseQuimicoMetalograficoState.values.resultado])

  const isFormAnaliseFisicoQuimicoInvalid = useMemo(() => {
    return !formAnaliseRevelacaoFisicoQuimicoState.values.resultado
  }, [formAnaliseRevelacaoFisicoQuimicoState.values.resultado])

  // --- HANDLERS DE AÇÃO ---

  const handleClickOpenFormularioExtracaoPadrao = useCallback(
    (descricaoTecnica) => {
      const tipo = descricaoTecnica.descVestBal?.tipo || '[TIPO]'
      const calibre =
        descricaoTecnica.descVestBal?.calibreNominal ||
        descricaoTecnica.descVestBal?.calibreCompativel ||
        '[CALIBRE]'
      const marca = descricaoTecnica.descVestBal?.marca || '[MARCA]'
      const numSerie = descricaoTecnica.descVestBal?.numeracaoDeSerie || '[NÚMERO DE SÉRIE]'
      const modelo = descricaoTecnica.descVestBal?.modelo
      
      let textoModelo = ''
      if (modelo && !['NÃO APARENTE', 'NÃO INFORMADO', 'PREJUDICADO'].includes(modelo.toUpperCase())) {
        textoModelo = `, modelo ${modelo}`
      }
      const textoDescricao = `Padrões balísticos coletados da arma de fogo  (${tipo}, ${marca}${textoModelo}, calibre ${calibre}, número de série ${numSerie})`
      
      setFormExtracaoState((prevState) => ({
        ...prevState,
        values: {
          lacre: null,
          tipoEmbalagem: null,
          outroTipoEmbalagem: null,
          tiposGens: [tiposVestigios.find((t) => t.identificador === 'BALISTICO')],
          tiposEsps: [tiposVestigiosEspecificos.find((t) => t.identificador === 'PADRAO')],
          tamanhoObjeto: null,
          descricao: textoDescricao,
          contraprova: null,
          setorAtual: null,
          caso: null,
        },
      }))
      
      fetchCasosDoObjetoOrigem(descricaoTecnica.id_vestigio)
      setDescricaoTecnicaSelecionada(descricaoTecnica)
      setOpenExtracaoPadrao(true)
    },
    [tiposVestigios, tiposVestigiosEspecificos, fetchCasosDoObjetoOrigem]
  )

  const handleClickOpenFormularioAnaliseConstatacao = useCallback(
    (descricaoTecnica) => {
      setFormAnaliseEficienciaState((prevState) => ({
        ...prevState,
        values: { resultado: null },
      }))
      setDescricaoTecnicaSelecionada(descricaoTecnica)
      setOpenAnaliseEficiencia(true)
    },
    []
  )

  const handleClickOpenFormularioAnaliseQuimicoMetalografico = useCallback(
    (idDescricaoVestigioBalistico) => {
      setFormAnaliseQuimicoMetalograficoState((prevState) => ({
        ...prevState,
        values: { resultado: null, numeroSerie: null, locGravs: [], localGravacaoNumeracaoSerieInput: null },
      }))
      setIdDescricaoVestigioBalisticoSelecionado(idDescricaoVestigioBalistico)
      setOpenAnaliseQuimicoMetalografico(true)
    },
    []
  )

  const handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico = useCallback(
    (idDescricaoVestigioBalistico) => {
      setFormAnaliseRevelacaoFisicoQuimicoState((prevState) => ({
        ...prevState,
        values: { resultado: null, numeroSerie: null, locGravs: [], localGravacaoNumeracaoSerieInput: null },
      }))
      setIdDescricaoVestigioBalisticoSelecionado(idDescricaoVestigioBalistico)
      setOpenAnaliseFisicoQuimico(true)
    },
    []
  )

  // Submissão dos Formulários
  const handleConfirmarExtracao = useCallback(async () => {
    if (!isFormExtracaoInvalid) {
      try {
        const novoVestigio = await vestigioService.extrairVestigioDeVestigio(
          descricaoTecnicaSelecionada.id_vestigio,
          formExtracaoState.values,
          setProcessandoOperacao
        )
        await descricaoTecnicaService.adicionarVestigioExtraidoDescricaoVestigioBalisticoAsync(
          descricaoTecnicaSelecionada.id,
          novoVestigio.id,
          setProcessandoOperacao
        )
        fetchDescricoesHabilitadasParaExtracaoDePadrao()
        setAtualizado((prev) => !prev)
        setOpenExtracaoPadrao(false)
      } catch (error) {
        console.error('Falha ao extrair padrão:', error)
      }
    }
  }, [isFormExtracaoInvalid, descricaoTecnicaSelecionada, formExtracaoState.values, fetchDescricoesHabilitadasParaExtracaoDePadrao])

  const handleConfirmarCadastroAnaliseEficiencia = useCallback(async () => {
    try {
      await exameEficienciaService.cadastrarAnaliseEficiencia(
        descricaoTecnicaSelecionada.id,
        params.idExameRealizado,
        formAnaliseEficienciaState.values,
        setProcessandoOperacao
      )
      setFormAnaliseEficienciaState((prevState) => ({
        ...prevState,
        touched: {},
        errors: {},
        values: { resultado: null },
      }))
      fetchDescricoesDeExame()
      setAtualizado((prev) => !prev)
      setOpenAnaliseEficiencia(false)
    } catch (error) {
      console.error('Falha ao cadastrar análise de eficiência:', error)
    }
  }, [descricaoTecnicaSelecionada, params.idExameRealizado, formAnaliseEficienciaState.values, fetchDescricoesDeExame])

  const handleConfirmarCadastroAnaliseQuimicoMetalografico = useCallback(async () => {
    try {
      await exameEficienciaService.cadastrarAnaliseQuimicoMetalografico(
        idDescricaoVestigioBalisticoSelecionado,
        params.idExameRealizado,
        formAnaliseQuimicoMetalograficoState.values,
        setProcessandoOperacao
      )
      setOpenAnaliseQuimicoMetalografico(false)
      fetchDescricoesHabilitadasParaExameQuimico()
      setAtualizado((prev) => !prev)
    } catch (error) {
      console.error('Falha ao cadastrar análise químico-metalográfica:', error)
    }
  }, [idDescricaoVestigioBalisticoSelecionado, params.idExameRealizado, formAnaliseQuimicoMetalograficoState.values, fetchDescricoesHabilitadasParaExameQuimico])

  const handleConfirmarCadastroAnaliseFisicoQuimico = useCallback(async () => {
    try {
      await exameEficienciaService.cadastrarAnaliseRevelacaoFisicoQuimico(
        idDescricaoVestigioBalisticoSelecionado,
        params.idExameRealizado,
        formAnaliseRevelacaoFisicoQuimicoState.values,
        setProcessandoOperacao
      )
      setOpenAnaliseFisicoQuimico(false)
      fetchDescricoesHabilitadasParaExameQuimico()
      setAtualizado((prev) => !prev)
    } catch (error) {
      console.error('Falha ao cadastrar análise física-química:', error)
    }
  }, [idDescricaoVestigioBalisticoSelecionado, params.idExameRealizado, formAnaliseRevelacaoFisicoQuimicoState.values, fetchDescricoesHabilitadasParaExameQuimico])

  const handleFinalizarExame = useCallback(async () => {
    try {
      setProcessandoAlteracaoRespostas(true)
      await exameRealizadoService.alterarRespostas({ respostasQuesitos }, setProcessandoAlteracaoRespostas)
      await exameRealizadoService.gerarDocumento(params.idExameRealizado, setProcessandoAlteracaoRespostas)
      
      router.history.push({
        pathname: `/casos/caso/solicitacao/exameSolicitado/editorExameRealizado/${params.idExameRealizado}`,
        state: { IgnoneUploadImagem: true, tipoExame: route.tipoExame },
      })
    } catch (error) {
      console.error('Falha ao finalizar exame balístico:', error)
    } finally {
      setProcessandoAlteracaoRespostas(false)
    }
  }, [respostasQuesitos, params.idExameRealizado, route.tipoExame, router.history])

  const handleVoltar = useCallback(() => {
    router.history.goBack()
  }, [router.history])

  return {
    currentUser,
    params,
    descricoesTecnicasDeExame,
    processandoDescricoesTecnicas,
    descricoesHabilitadasParaExameQuimico,
    descricoesHabilitadasParaExtracaoDePadrao,
    casosDoObjetoOrigem,
    locaisGravacoesNumeracaoDeSerie,
    tiposVestigios,
    tiposVestigiosEspecificos,
    descricaoTecnicaSelecionada,
    processandoOperacao,
    processandoAlteracaoRespostas,
    setRespostasQuesitos,

    openAnaliseEficiencia,
    setOpenAnaliseEficiencia,
    openExtracaoPadrao,
    setOpenExtracaoPadrao,
    openAnaliseQuimicoMetalografico,
    setOpenAnaliseQuimicoMetalografico,
    openAnaliseFisicoQuimico,
    setOpenAnaliseFisicoQuimico,

    formExtracao,
    formAnaliseEficiencia,
    formAnaliseQuimicoMetalografico,
    formAnaliseRevelacaoFisicoQuimico,

    isFormExtracaoInvalid,
    isFormEficienciaInvalid: isFormAnaliseEficienciaInvalid,
    isFormQuimicoMetalograficoInvalid,
    isFormAnaliseFisicoQuimicoInvalid,

    handleClickOpenFormularioExtracaoPadrao,
    handleClickOpenFormularioAnaliseConstatacao,
    handleClickOpenFormularioAnaliseQuimicoMetalografico,
    handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico,

    handleConfirmarExtracao,
    handleConfirmarCadastroAnaliseEficiencia,
    handleConfirmarCadastroAnaliseQuimicoMetalografico,
    handleConfirmarCadastroAnaliseFisicoQuimico,
    handleFinalizarExame,
    handleVoltar,
    setAtualizado,
  }
}
